// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LegendeSettingsItem_row__2W10s td {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n.LegendeSettingsItem_row__2W10s:last-child td {\n  border-bottom: none;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Legende/LegendeSettingsItem.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".row td {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n.row:last-child td {\n  border-bottom: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": "LegendeSettingsItem_row__2W10s"
};
export default ___CSS_LOADER_EXPORT___;
